<template>

  <v-container>
    <v-overlay :value="loading_overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-container>
        <div>Attivita {{ $route.params.id }}</div>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              label="Cod"
              v-model="form.cod.val"
              :rules="[rules.required, rules.max(255)]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              label="Descrizione"
              v-model="form.descrizione.val"
              :rules="[rules.required, rules.max(255)]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea label="Nota" v-model="form.nota.val" rows="2">
            </v-textarea>
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
              label="Responsabile"
              v-model="form.responsabile_id_default.val"
              :item-text="(item) => `${item.name} - ${item.email}`"
              item-value="id"
              :items="this.selects.responsabile_id_default"
              cache-items
            >
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-autocomplete
              ref="attivita_4select" 
              label="Scegli attività da collegare"
              :menu-props="{closeOnContentClick:true}"
              v-model="attivita_4select_model"
              :item-text="(item) => `${item.cod} - ${item.descrizione}`"
              item-value="id"
              :items="this.attivita_4select"
              append-outer-icon="mdi-plus"
              @click:append-outer="appendAttivita();$refs.attivita_4select.isMenuActive=false"
              :loading="attivita_select_loading"
              multiple
              cache-items
              return-object
              clearable
            >
            </v-autocomplete>
            <v-list outlined rounded>
              <v-list-item
                v-show="
                  attivita_collegate == null || attivita_collegate.length == 0
                "
              >
                <v-list-item-avatar>
                  <v-icon>mdi-information-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    >Nessuna Attività collegata</v-list-item-title
                  >
                  <v-list-item-subtitle class="overline"
                    >per collegare scegli e premi sul +</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <template
                two-line
                v-for="(attivita, index) in attivita_collegate"
              >
                <v-list-item :key="index">
                  <v-list-item-avatar>
                    <v-icon>mdi-text-box-outline</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ attivita.cod }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      attivita.descrizione
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-action>
                    <v-row justify="end">
                      <v-col class="col-auto">
                        <v-text-field
                          label="Days Offset"
                          style="width: 100px"
                          hide-details="auto"
                          v-model="attivita.offset_day_scadenza"
                          :rules="[rules.integer]"
                          reverse
                        ></v-text-field>
                      </v-col>
                      <v-col class="col-auto">
                        <v-btn icon @click="removeAttivitaCollegata(attivita)">
                          <v-icon>mdi-close-circle</v-icon></v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-list-item-action>
                </v-list-item>
                <v-divider
                  v-if="index !== attivita_collegate.length - 1"
                  :key="'divider_' + index"
                ></v-divider>
              </template>
            </v-list>
          </v-col>
        </v-row>

        <SchedaToolbar
          :error_show="error_show"
          :error_text="error_text"
          :edit_not_saved="edit_not_saved"
          :edit_mode="editMode"
          :new_button_visibile="true"
          :speed-dial-visible="true"
          :speed-dial-title="this.form.cod.val ? this.form.cod.val : 'COD' "
          v-on:newItemClick="newItem()"
          v-on:saveItemClick="saveItem()"
          v-on:goBackClick="goBack()"
        />
      </v-container>
    </v-form>
  </v-container>

</template>

<script>
import schedaMixin from "@/mixins/SchedaMixin.js";
import ValidationRulesMixin from "@/mixins/ValidationRulesMixin.js";
import SchedaToolbar from "@/components/SchedaToolbar.vue";
import mj_axios from "@/mj_axios.js";

export default {
  name: "SchedaAttivita",
  mixins: [schedaMixin, ValidationRulesMixin],
  components: { SchedaToolbar },
  data: () => ({
    attivita_4select: [],
    attivita_4select_model: null,
    attivita_select_loading: false,
    attivita_collegate: [
      //test data
      /*{ id: 1, cod: "a1", descrizione: "Attivita A!!1", day_offset: 3 },
      { id: 3, cod: "a1", descrizione: "Attivita A!!1", day_offset: 3 },*/
    ],
    form: {
      cod: { type: "string", val: "", default_val: "" },
      descrizione: { type: "string", val: "", default_val: "" },
      nota: { type: "text", val: "", default_val: "" },

      responsabile_id_default: {
        type: "integer",
        val: "",
        default_val: "",
        loadSelect: true,
        apiUrl: "/api/user/users",
      },
    },
    apiUrl: "/api/attivita",
  }),
  created: function () {
    this.loadAttivitaSelect();
  },
  methods: {
    loadAttivitaSelect: function () {
      this.attivita_select_loading = true;
      const filter_array = [{ name: "AttivitaCollegate", type: "has_not" }];
      const filter_part = `filters=${JSON.stringify(filter_array)}`;

      mj_axios
        .get(
          `/api/list/Attivita/AttivitaResource4SelectCollection?${filter_part}`
        )
        .then((response) => {
          this.attivita_4select = response.data.data;
          // this.loading_overlay = false;
          this.attivita_select_loading = false;
        })
        .catch(() => {
          this.error_show = true;
          this.error_text = "Errore nel caricamento dati";
          // this.loading_overlay = false;
          this.attivita_select_loading = false;
        });
    },
    //ovverride + metodi aggiuntivi
    loadItem: function () {
      return schedaMixin.methods.loadItem.call(this).then(() => {
        const macro_attivita_id = this.$route.params.id;
        this.loadAttivitaCollegate(macro_attivita_id);
      });
    },
    saveItem: function () {
      //ovverride + metodi aggiuntivi

      schedaMixin.methods.saveItem.call(this).then(() => {
        const macro_attivita_id = this.$route.params.id;
        this.saveAttivitaCollegate(macro_attivita_id);
      });
    },

    appendAttivita: function () {
      this.attivita_4select_model.forEach((a) => {
        this.attivita_collegate.push(a);
      });
      this.attivita_4select_model = [];
    },
    removeAttivitaCollegata: function (attivita) {
      this.attivita_collegate.splice(
        this.attivita_collegate.indexOf(attivita),
        1
      );
    },
    loadAttivitaCollegate: function (macro_attivita_id) {
      this.loading_overlay = true;

      mj_axios
        .get("/api/attivita_collegate/" + macro_attivita_id)
        .then((response) => {
          if (response.data) {
            this.attivita_collegate = [];
            this.attivita_collegate = response.data.data;
          }
        })
        .catch((e) => {
          // const status = (e.response) ? e.response.status : null;
          let message =
            e.response && e.response.data ? e.response.data.message : null;

          this.error_show = true;
          this.error_text = `Errore nel Caricamento Attivita Collegate ${
            message ? message : ""
          }`;
        })
        .then(() => {
          this.loading_overlay = false;
        });
    },
    saveAttivitaCollegate: function (macro_attivita_id) {
      
      this.loading_overlay = true;

      const headers = {
        "Content-Type": "application/json",
      };
      const params = { attivita_collegate: this.attivita_collegate };
      mj_axios
        .put(
          "/api/attivita_collegate/" + macro_attivita_id,
          JSON.stringify(params),
          { headers: headers }
        )
        .then(() => {})
        .catch((e) => {
          // const status = (e.response) ? e.response.status : null;
          let message =
            e.response && e.response.data ? e.response.data.message : null;

          this.error_show = true;
          this.error_text = `Errore nel Salvataggio dati  ${
            message ? message : ""
          }`;
        })
        .then(() => {
          this.loading_overlay = false;
        });
    },
  },
};
</script>
